import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ec5077"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vip" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "top-line" }, null, -1))
const _hoisted_5 = { class: "fs-20 pt-90 mb-4 color-white text-center" }
const _hoisted_6 = { class: "fs-20 mb-36 color-white-75 text-center" }
const _hoisted_7 = { class: "fs-16 color-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CusModal = _resolveComponent("CusModal")!

  return (_openBlock(), _createBlock(_component_CusModal, {
    isShow: _ctx.isShowTurnVipModal,
    maskClosable: true,
    width: "600px",
    class: "turnVip",
    onOnClose: _ctx.hideTurnVipModal,
    zIndex: 2999
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "vip-img",
          src: require('@/assets/img/vip-dialog.png'),
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "vip-img-bg",
          src: require('@/assets/img/bg_pic_v.png'),
          alt: ""
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("TurnVipModal.Exclusive")), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("TurnVipModal.Subscribe")), 1),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.turnVipPage && _ctx.turnVipPage(...args))),
          class: "vip-btn flex justify-center items-center cursor-pointer"
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.btnDesc), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isShow", "onOnClose"]))
}